import {
  Box,
  Container,
  FormControl,
  Grid,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const LoadingAndUnLoading = ({
  handleChangePdLoadingUnloading,
  id,
  handlelUnLCountDelete,
}) => {
  const classes = useStyles();
  const [loadingUnDetails, setLoadingUnDetails] = useState();
  const [locationTo, setLocationTo] = useState();
  const [render, setRender] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      const res = await axios(
        `https://abc-backend.onrender.com/api/quotes/${id}`
      );
      setLoadingUnDetails(
        res.data.data?.loadingUnDetailsValue.length > 0
          ? res.data.data?.loadingUnDetailsValue
          : [{ test: "test" }]
      );
    };

    fetchData();
  }, [id]);

  const hanldeIncrementLD = () => {
    const loadingUnloadin = loadingUnDetails;
    loadingUnloadin.push({ test: "test" });
    setLoadingUnDetails(loadingUnloadin);
    setRender(render + 1);
  };
  const handleCountDelete = (i) => {
    const filterCount = loadingUnDetails.filter((_, index) => index !== i);
    setLoadingUnDetails(filterCount);
    console.log({ filterCount });
    handlelUnLCountDelete(i);
  };
  return (
    <>
      <div className="desktop">
        {loadingUnDetails?.map((ldData, i) => (
          <Box className="loadingUnloadingDetalis" key={i}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                padding: "15px 10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "10px",
                }}
              >
                <Typography variant="span">
                  <HomeIcon />
                </Typography>
                <Typography variant="h6">
                  Loading And UnLoading Details
                </Typography>
              </Box>
              <Box>
                {i !== 0 ? (
                  <button
                    className="quote_loadingUn_btn"
                    onClick={() => handleCountDelete(i)}
                  >
                    <DeleteIcon />
                  </button>
                ) : (
                  <p></p>
                )}
              </Box>
            </Box>
            <Container>
              <Box className="loadingUnloadingHeading">
                <Box className="loadingUnloadingHeading1">
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">From</Typography>
                </Box>
                <Box className="loadingUnloadingHeading2">
                  <Typography variant="h6">To</Typography>
                </Box>
                <Box className="loadingUnloadingHeading3">
                  <Typography variant="span">
                    <AddIcon onClick={hanldeIncrementLD} />
                  </Typography>
                </Box>
              </Box>
            </Container>
            <Container>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={4} md={4}>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Location
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Loading Method
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Equipment Required
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Site Inspection
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Contact Person Name
                  </Typography>
                  <Typography variant="h6" className="loadingUnloadingTitle">
                    Contact Person Phone Number
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      required
                      name="locationFrom"
                      label="Location"
                      variant="outlined"
                      value={locationTo}
                      defaultValue={
                        ldData.locationFrom ? ldData.locationFrom : ""
                      }
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                      onChange={(e) => setLocationTo(e.target.value)}
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl variant="outlined" required>
                      <Select
                        required
                        native
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="loadingMethodFrom"
                      >
                        <option
                          aria-label="None"
                          value={ldData.loadingMethodFrom}
                          selected
                          defaultValue={
                            ldData.loadingMethodFrom
                              ? ldData.loadingMethodFrom
                              : ""
                          }
                        >
                          {ldData.loadingMethodFrom}
                        </option>
                        <option value="Top">Top</option>
                        <option value="Side">Side</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl variant="outlined">
                      <Select
                        required
                        native
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="equipmentRequiredFrom"
                      >
                        <option
                          aria-label="None"
                          value={ldData.equipmentRequiredFrom}
                          selected
                          defaultValue={
                            ldData.equipmentRequiredFrom
                              ? ldData.equipmentRequiredFrom
                              : ""
                          }
                        >
                          {ldData.equipmentRequiredFrom}
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        required
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="siteInspectionFrom"
                      >
                        <option
                          aria-label="None"
                          value={ldData.siteInspectionFrom}
                          selected
                          defaultValue={
                            ldData.siteInspectionFrom
                              ? ldData.siteInspectionFrom
                              : ""
                          }
                        >
                          {ldData.siteInspectionFrom}
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      required
                      name="contactPersonNameFrom"
                      label="Contact Person Name"
                      variant="outlined"
                      defaultValue={
                        ldData.contactPersonNameFrom
                          ? ldData.contactPersonNameFrom
                          : ""
                      }
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      required
                      name="PhoneNumberFrom"
                      label="Person Phone Number"
                      variant="outlined"
                      defaultValue={
                        ldData.PhoneNumberFrom ? ldData.PhoneNumberFrom : ""
                      }
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      required
                      name="locationTo"
                      label="Location"
                      variant="outlined"
                      defaultValue={ldData.locationTo ? ldData.locationTo : ""}
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="loadingMethodTo"
                      >
                        <option
                          aria-label="None"
                          value={ldData.loadingMethodTo}
                          selected
                          defaultValue={
                            ldData.loadingMethodTo ? ldData.loadingMethodTo : ""
                          }
                        >
                          {ldData.loadingMethodTo}
                        </option>
                        <option value="Top">Top</option>
                        <option value="Side">Side</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="equipmentRequiredTo"
                      >
                        <option
                          aria-label="None"
                          value={ldData.equipmentRequiredTo}
                          selected
                          defaultValue={
                            ldData.equipmentRequiredTo
                              ? ldData.equipmentRequiredTo
                              : ""
                          }
                        >
                          {ldData.equipmentRequiredTo}
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <Select
                        native
                        onBlur={(event) =>
                          handleChangePdLoadingUnloading(event, i)
                        }
                        name="siteInspectionTo"
                      >
                        <option
                          aria-label="None"
                          value={ldData.siteInspectionTo}
                          selected
                          defaultValue={
                            ldData.siteInspectionTo
                              ? ldData.siteInspectionTo
                              : ""
                          }
                        >
                          {ldData.siteInspectionTo}
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="contactPersonNameTo"
                      label="Contact Person Name"
                      variant="outlined"
                      defaultValue={
                        ldData.contactPersonNameTo
                          ? ldData.contactPersonNameTo
                          : ""
                      }
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                    />
                  </Box>
                  <Box className="loadinUnloadingInput">
                    <TextField
                      name="PhoneNumberTo"
                      label="Person Phone Number"
                      variant="outlined"
                      onBlur={(event) =>
                        handleChangePdLoadingUnloading(event, i)
                      }
                      defaultValue={
                        ldData.PhoneNumberTo ? ldData.PhoneNumberTo : ""
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        ))}
      </div>
      <>
        {loadingUnDetails?.map((ldData, i) => (
          <Box className="loadingUnloadingDetalis mobile" key={i}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                padding: "15px 10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "10px",
                }}
              >
                <Typography variant="span">
                  <HomeIcon />
                </Typography>
                <Typography variant="h6">
                  Loading And UnLoading Details
                </Typography>
              </Box>
              <Box>
                {i !== 0 ? (
                  <button
                    className="quote_loadingUn_btn"
                    onClick={() => handleCountDelete(i)}
                  >
                    <DeleteIcon />
                  </button>
                ) : (
                  <p></p>
                )}
              </Box>
            </Box>
            <Container>
              <Box className="loadingUnloadingHeading">
                <Box className="loadingUnloadingHeading1">
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">From</Typography>
                </Box>
                <Box className="loadingUnloadingHeading2">
                  <Typography variant="h6">To</Typography>
                </Box>
                <Box className="loadingUnloadingHeading3">
                  <Typography variant="span">
                    <AddIcon onClick={hanldeIncrementLD} />
                  </Typography>
                </Box>
              </Box>
            </Container>
            <Container>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={4} md={4}>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Location
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          required
                          name="locationFrom"
                          label="Location"
                          variant="outlined"
                          value={locationTo}
                          defaultValue={
                            ldData.locationFrom ? ldData.locationFrom : ""
                          }
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                          onChange={(e) => setLocationTo(e.target.value)}
                        />
                      </Box>{" "}
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="locationTo"
                          label="Location"
                          variant="outlined"
                          required
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Loading Method
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined" required>
                          <Select
                            required
                            native
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="loadingMethodFrom"
                          >
                            <option
                              aria-label="None"
                              value={ldData.loadingMethodFrom}
                              selected
                              defaultValue={
                                ldData.loadingMethodFrom
                                  ? ldData.loadingMethodFrom
                                  : ""
                              }
                            >
                              {ldData.loadingMethodFrom}
                            </option>
                            <option value="Top">Top</option>
                            <option value="Side">Side</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="loadingMethodTo"
                          >
                            <option
                              aria-label="None"
                              value={ldData.loadingMethodTo}
                              selected
                              defaultValue={
                                ldData.loadingMethodTo
                                  ? ldData.loadingMethodTo
                                  : ""
                              }
                            >
                              {ldData.loadingMethodTo}
                            </option>
                            <option value="Top">Top</option>
                            <option value="Side">Side</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Equipment Required
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            required
                            native
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="equipmentRequiredFrom"
                          >
                            <option
                              aria-label="None"
                              value={ldData.equipmentRequiredFrom}
                              selected
                              defaultValue={
                                ldData.equipmentRequiredFrom
                                  ? ldData.equipmentRequiredFrom
                                  : ""
                              }
                            >
                              {ldData.equipmentRequiredFrom}
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="equipmentRequiredTo"
                          >
                            <option
                              aria-label="None"
                              value={ldData.equipmentRequiredTo}
                              selected
                              defaultValue={
                                ldData.equipmentRequiredTo
                                  ? ldData.equipmentRequiredTo
                                  : ""
                              }
                            >
                              {ldData.equipmentRequiredTo}
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Site Inspection
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            required
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="siteInspectionTo"
                          >
                            <option
                              aria-label="None"
                              value=""
                              selected
                              disabled
                            >
                              Please select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Select>
                        </FormControl>
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <FormControl variant="outlined">
                          <Select
                            native
                            onBlur={(event) =>
                              handleChangePdLoadingUnloading(event, i)
                            }
                            name="loadingMethodTo"
                          >
                            <option
                              aria-label="None"
                              value={ldData.loadingMethodTo}
                              selected
                              defaultValue={
                                ldData.loadingMethodTo
                                  ? ldData.loadingMethodTo
                                  : ""
                              }
                            >
                              {ldData.loadingMethodTo}
                            </option>
                            <option value="Top">Top</option>
                            <option value="Side">Side</option>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    {" "}
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Contact Person Name
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          required
                          name="contactPersonNameFrom"
                          label="Name"
                          variant="outlined"
                          defaultValue={
                            ldData.contactPersonNameFrom
                              ? ldData.contactPersonNameFrom
                              : ""
                          }
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="contactPersonNameTo"
                          label="Name"
                          variant="outlined"
                          defaultValue={
                            ldData.contactPersonNameTo
                              ? ldData.contactPersonNameTo
                              : ""
                          }
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mobileLoading">
                    <Typography variant="h6" className="loadingUnloadingTitle">
                      Contact Person Phone Number
                    </Typography>
                    <Box className="subMobileLoading">
                      <Box className="loadinUnloadingInput">
                        <TextField
                          required
                          name="PhoneNumberFrom"
                          label="Phone Number"
                          variant="outlined"
                          defaultValue={
                            ldData.PhoneNumberFrom ? ldData.PhoneNumberFrom : ""
                          }
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                        />
                      </Box>
                      <div className="line_box"></div>
                      <Box className="loadinUnloadingInput">
                        <TextField
                          name="PhoneNumberTo"
                          label="Phone Number"
                          variant="outlined"
                          onBlur={(event) =>
                            handleChangePdLoadingUnloading(event, i)
                          }
                          defaultValue={
                            ldData.PhoneNumberTo ? ldData.PhoneNumberTo : ""
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        ))}
      </>
    </>
  );
};

export default LoadingAndUnLoading;
